module.exports = __webpack_public_path__ + "img/refresh@2x.9c3b221f.svg";